<template>
  <Header fixed="top" class="background-white">
    <header-brand :to="{ name: 'Home' }">
      <header-brand-logo :src="require('@/assets/logo.svg')"></header-brand-logo>
      <header-brand-name class="text-primary">Authcore</header-brand-name>
    </header-brand>
    <header-content v-if="!isLoggedIn && ready" class="scroll-row">
      <header-item :to="{ name: 'Register' }">{{ $t('general.register') }}</header-item>
      <header-item :to="{ name: 'SignIn' }">{{ $t('general.sign_in') }}</header-item>
    </header-content>
    <header-content v-else-if="isLoggedIn && ready" class="scroll-row">
      <header-item disabled>
        {{ user.displayName }}
      </header-item>
      <header-item
        v-if="managementEnabled"
        :to="{ name: 'ManagementHome' }"
        :active="subIsActive('/management')">
        {{ $t('general.management') }}
      </header-item>
      <header-item
        :to="{ name: 'Profile' }"
        :active="subIsActive('/settings')">
        {{ $t('general.settings') }}
      </header-item>
      <header-item @click="logout">{{ $t('general.sign_out') }}</header-item>
    </header-content>
  </Header>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import store from '@/store'

export default {
  name: 'NavigationBar',
  components: {},

  props: {},

  data () {
    return {}
  },

  computed: {
    ...mapState('management', [
      'ready'
    ]),
    ...mapState('currentUser', [
      'user'
    ]),
    ...mapState('currentUser/permissions', [
      'permissions'
    ]),
    ...mapGetters('currentUser', [
      'isLoggedIn'
    ]),
    managementEnabled () {
      return this.permissions !== undefined ? this.permissions.length > 0 : false
    }
  },

  watch: {},

  created () {},
  mounted () {},
  updated () {},
  destroyed () {},

  methods: {
    logout () {
      store.dispatch('client/logout')
    },
    // For parent `sidebar-item` require this function to check the path to activate the visible and active states
    // Check if the sub item href includes the input result
    subIsActive (input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0 // current path starts with this path string
      })
    }
  }
}
</script>
